const isCityPairAllowed = (cityPairs, departureCity, arrivalCity) => {
    if (typeof cityPairs[departureCity] === 'undefined') {
        return false;
    }

    const haystack = cityPairs[departureCity];

    return haystack.indexOf(arrivalCity) !== -1;
};

/**
 * Given the cities information, this function will return
 * the available options for arrival location.
 *
 * @todo Write tests
 */
export const getArrivalOptions = (
    departureOptions,
    cities,
    cityPairs,
    selectedDepartureCityId,
    getCityGroup,
) => {
    // When the city pair array is empty, return nothing
    if (Object.keys(cityPairs).length === 0) {
        return [];
    }

    const newResults = [];

    departureOptions.forEach((option) => {
        if (!isCityPairAllowed(cityPairs, selectedDepartureCityId, option.cityId)) return;

        const newOption = {
            ...option,
        };

        if (typeof getCityGroup === 'function') {
            newOption.group = getCityGroup(option, selectedDepartureCityId);
        }

        newResults.push(newOption);
    });

    return newResults;
};
